<script lang="ts">
import twemoji from '@twemoji/api';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Emojify',

    mounted() {
        this.parse();
    },

    updated() {
        this.parse();
    },

    render() {
        return this.$slots.default?.()[0];
    },

    methods: {
        parse() {
            if (!twemoji.test(this.$el.textContent || '')) return;

            twemoji.parse(this.$el, { folder: 'svg', ext: '.svg' });
        },
    },
});
</script>
